import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import wrapLogo from '../assets/w.png';
import './Navbar.css';

const Navbar: React.FC = () => {
  const location = useLocation();

  const handleLogoClick = (e: React.MouseEvent) => {
    // If we're already on the home page, just smooth scroll to top
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      // Let the Link component handle navigation to home page
      // Don't prevent default so the link works normally
    }
  };

  return (
    <nav className="nav nav--glossy">
      <Link 
        to="/" 
        className="nav__logo"
        onClick={handleLogoClick}
      >
        <img src={wrapLogo} alt="Wrap" className="nav__logo-img" />
      </Link>
      <div className="nav__container">
        <div className="nav__links">
          <a href="#about" className="nav__link">About us</a>
          <Link to="/careers" className={`nav__link${location.pathname === '/careers' ? ' active' : ''}`}>Careers</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;


